"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("./Text"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1.25;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Heading = _Text["default"].withComponent('h2').extend(_templateObject());

Heading.displayName = 'Heading';
Heading.defaultProps = {
  theme: _theme["default"],
  regular: true,
  fontSize: 5,
  m: 0
};
Heading.h1 = (0, _styledComponents["default"])(Heading.withComponent('h1'))(_templateObject2());
Heading.h1.defaultProps = {
  bold: true,
  fontSize: 6,
  m: 0
};
Heading.h2 = Heading.withComponent('h2');
Heading.h2.defaultProps = {
  bold: true,
  fontSize: 5,
  m: 0
};
Heading.h3 = Heading.withComponent('h3');
Heading.h3.defaultProps = {
  bold: true,
  fontSize: 4,
  m: 0
};
Heading.h4 = Heading.withComponent('h4');
Heading.h4.defaultProps = {
  regular: true,
  fontSize: 3,
  m: 0
};
Heading.h5 = Heading.withComponent('h5');
Heading.h5.defaultProps = {
  bold: true,
  fontSize: 2,
  m: 0
};
Heading.h6 = Heading.withComponent('h6');
Heading.h6.defaultProps = {
  bold: true,
  caps: true,
  fontSize: 0,
  m: 0
};
var _default = Heading;
exports["default"] = _default;